export default __webpack_public_path__ + "static/media/newest.96480326.svg";